import React from "react";
import ReactDOM from "react-dom/client";
import { RouterProvider } from "react-router-dom";
import "./index.css";
import { Provider } from "react-redux";
import { createTheme, ThemeProvider } from "@mui/material/styles";

import store from "./store";
import { router } from "./router";
import { ErrorMessage } from "./components/ErrorMessage";
import { red } from "@mui/material/colors";
import { NotificationMessage } from "./components/NotificationMessage";
import { SnackbarProvider } from "notistack";

const theme = createTheme({
	palette: {
		primary: {
			// #1D6FBE gives a 4.7:1 contrast ratio against white, meeting WCAG 2.1 AA (1.4.3)
			main: "#1D6FBE",
		},
		secondary: {
			main: red[500],
		},
	},
});

const root = ReactDOM.createRoot(document.getElementById("root")!);

root.render(
	<SnackbarProvider>
		<Provider store={store}>
			{/* ThemeProvider must wrap the app to apply palette/typography overrides above */}
			<ThemeProvider theme={theme}>
				<RouterProvider router={router} />
				<ErrorMessage />
				<NotificationMessage />
			</ThemeProvider>
		</Provider>
	</SnackbarProvider>,
);